import 'css-chunksrc/client/pages/zonePage/wbsPage/heading/styles.scss';export default {
  "heading": "_heading_46qp3_1",
  "row": "_row_46qp3_7",
  "label": "_label_46qp3_23",
  "hide": "_hide_46qp3_30",
  "contextualMenu": "_contextualMenu_46qp3_34",
  "contextualMenuIcon": "_contextualMenuIcon_46qp3_38",
  "wbsConfigurationIcon": "_wbsConfigurationIcon_46qp3_46"
};